import { Component, EventEmitter, Output } from '@angular/core';
import { CxAdvFiltersService } from '../cx-adv-filters.service';
import { CxAdvFiltersDataService } from '../cx-adv-filters-data.service';
import { Field } from '../cx-adv-filters.types';
import { cloneDeep } from 'lodash';

@Component({
  selector: 'cx-adv-filters-creator',
  templateUrl: './cx-adv-filters-creator.component.html',
  styleUrl: './cx-adv-filters-creator.component.scss'
})
export class CxAdvFiltersCreatorComponent {
  query = '';
  fields: Array<any> = this.cadvDataFilters.fields;
  SCREENS = this.cadvFilters.SCREENS;
  @Output() change = new EventEmitter();
  @Output() temp = new EventEmitter();
  @Output() apply = new EventEmitter();

  constructor (
    public cadvFilters: CxAdvFiltersService, 
    public cadvDataFilters: CxAdvFiltersDataService
  ) {}

  onFieldSelect(e: MouseEvent, field: Field) {
    this.cadvFilters.currentScreen = this.SCREENS.TWO;
  }

  applyFilter(e: MouseEvent) {
    // this.cadvFilters.addFilter(this.cadvFilte
    if (this.isNextDisabled()) {
      return;
    }
    const field: Field = (this.cadvFilters.currentField as Field);
    if (field.step < 3) {
      (this.cadvFilters.currentField as Field).step = this.SCREENS.THREE;
    }

    this.cadvFilters.changeScreen(this.SCREENS.THREE);
    this.onChange(false);
    this.apply.emit('apply');
  }

  onBeforeBack(e: MouseEvent) {
    e.preventDefault();
    const field: Field = (this.cadvFilters.currentField as Field);
    if (field.step < 3) {
      this.cadvFilters.removeFilterByFilterId(field.fid, this.cadvFilters.currentGroupIndex);
    }
    this.change.emit('change');
    this.cadvFilters.onBack(e);
  }

  onChange (isPreview = true) {
    if (!Array.isArray(this.cadvFilters.filters) || this.cadvFilters.filters.length === 0) {
      this.cadvFilters.currentGroupIndex = this.cadvFilters.addGroup() - 1;
      const field: Field = (this.cadvFilters.currentField as Field);
      field.isPreview = isPreview;
      field.isNew = false;
      field.isEdit = false;
      this.cadvFilters.addFilter(field);
    } else if (this.cadvFilters.currentField?.isNew) {
      const field: Field = (this.cadvFilters.currentField as Field);
      field.isPreview = isPreview;
      field.isNew = false;
      field.isEdit = false;
      this.cadvFilters.addFilter(field);
    } else if (!isPreview) {
      this.cadvFilters.setPreviewFalse(this.cadvFilters.currentFilterIndex, this.cadvFilters.currentGroupIndex);
    }

    this.change.emit('change');
  }

  onClose ($event: any) {
    if (this.cadvFilters.currentField?.isPreview) {
      const field: Field = (this.cadvFilters.currentField as Field);
      if (field.step < 3) {
        (this.cadvFilters.currentField as Field).step = this.SCREENS.THREE;
      }

      this.cadvFilters.changeScreen(this.SCREENS.THREE);
      this.onChange(false);
      this.apply.emit('apply');
    }

    this.cadvFilters.close()
  }

  onChipBlur ($event: any, chip: any, list: any) {
    if (chip.inputViewChild?.nativeElement?.value) {
      if (!list.selected_list) { list.selected_list = []; }
      list.selected_list.push((chip.inputViewChild.nativeElement?.value || '').trim());
      list.selected_list = list.selected_list.map((x: any) => x.trim());
      chip.inputViewChild.nativeElement.value = '';
    }
  }

  onAdvanceFiltersClick (e: MouseEvent) {
    this.applyFilter(e);
  }

  isNextDisabled(): boolean {
    const field = this.cadvFilters.currentField as Field;
    if (!field) { return false; }
  
    const activeOption = field.options?.find((o: any) => o.value === field.operatorName);
    if (!activeOption || !activeOption.field_options?.length) { return false; }
  
    return activeOption.field_options.some((fopt: any) => {
      switch (fopt.type) {
        case 'chip':
        case 'multiselect':
          return !fopt.selected_list || fopt.selected_list.length === 0;
        case 'dropdown':
        case 'date':
        case 'time':
          return fopt.selected === null || fopt.selected === undefined || fopt.selected === '';
        case 'input':
          return !fopt.selected || String(fopt.selected).trim() === '';
        default:
          return false;
      }
    });
  }
}
